// Öffnet das Handbuch-PDF robust — umgeht den Service-Worker-Navigations-
// Fallback (der /HANDBUCH.pdf sonst zur App umleitet), indem die Datei per
// fetch() geholt und als Blob-URL geöffnet wird. Das leere Fenster wird
// synchron im Klick-Kontext geöffnet, damit der Popup-Blocker nicht greift.

export function openHandbuch(): void {
  const win = window.open('', '_blank', 'noopener');
  fetch('/HANDBUCH.pdf', { cache: 'reload' })
    .then(r => {
      if (!r.ok) throw new Error(`HTTP ${r.status}`);
      return r.blob();
    })
    .then(blob => {
      const url = URL.createObjectURL(blob);
      if (win !== null) {
        win.location.href = url;
      } else {
        // Popup wurde blockiert → im selben Tab öffnen
        window.location.href = url;
      }
      setTimeout(() => { URL.revokeObjectURL(url); }, 60_000);
    })
    .catch(() => {
      // Fallback: direkter Navigationsversuch
      if (win !== null) win.location.href = '/HANDBUCH.pdf';
      else window.open('/HANDBUCH.pdf', '_blank', 'noopener');
    });
}
